module.exports = "<div class=\"download\" (click)=\"downloadFile()\"> {{'DOCUMENTS.DOWNLOAD' | translate }}</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/download-file-document/download-file-document.component.html
// module id = ./src/app/shared/components/download-file-document/download-file-document.component.html
// module chunks = main